var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "ruleForm",
          attrs: { model: _vm.transVoucherInfo, rules: _vm.rules }
        },
        [
          _c("div", { staticClass: "simple-form" }, [
            _vm.principalId != null && !_vm.transVoucherInfo.crossFlag
              ? _c("div", { staticClass: "form-group center" }, [
                  _c("div", { staticClass: "form-label" }),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "form-value" },
                    [
                      _c(
                        "el-checkbox",
                        {
                          model: {
                            value: _vm.transVoucherInfo.autoReceive,
                            callback: function($$v) {
                              _vm.$set(_vm.transVoucherInfo, "autoReceive", $$v)
                            },
                            expression: "transVoucherInfo.autoReceive"
                          }
                        },
                        [_vm._v("机构负责人自动领用")]
                      )
                    ],
                    1
                  )
                ])
              : _vm._e()
          ])
        ]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "table-layout" },
        [
          _c(
            "el-table",
            {
              ref: "multipleTable",
              attrs: {
                data: _vm.transVoucherInfo.itemList,
                border: "",
                "tooltip-effect": "dark"
              }
            },
            [
              _c("el-table-column", {
                attrs: { align: "left", prop: "title", label: "耗材描述全称" }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "model",
                  width: "180",
                  label: "型号"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "fixedSpec",
                  width: "180",
                  label: "规格"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "name",
                  width: "180",
                  label: "名称"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "catName",
                  label: "分类",
                  width: "120"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "groupName",
                  label: "分类分组",
                  width: "120",
                  align: "left",
                  "show-overflow-tooltip": ""
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(rows) {
                      return [
                        _c("span", [
                          _vm._v(
                            _vm._s(_vm.getGoodsCatDevcGroupName(rows.row.catId))
                          )
                        ])
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "brandName",
                  label: "品牌",
                  width: "100"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "batchNo",
                  label: "批次号",
                  width: "150"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: { prop: "dstComName", label: "调入部门", width: "140" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        scope.row.dstComName != null
                          ? _c("span", { attrs: { align: "left" } }, [
                              _vm._v(_vm._s(scope.row.dstComName))
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _c(
                          "a",
                          {
                            staticClass: "swb-btn-link",
                            attrs: { align: "right" },
                            on: {
                              click: function($event) {
                                _vm.selectDstComName(scope.$index)
                              }
                            }
                          },
                          [_vm._v("选择部门")]
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  prop: "dstWarehouseName",
                  label: "调入仓库",
                  width: "140",
                  align: "center"
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(scope) {
                      return [
                        _c(
                          "el-select",
                          {
                            attrs: { placeholder: "请选择" },
                            on: {
                              change: function($event) {
                                _vm.selectDstWarehouse(scope.$index)
                              }
                            },
                            model: {
                              value: scope.row.dstWarehouseId,
                              callback: function($$v) {
                                _vm.$set(scope.row, "dstWarehouseId", $$v)
                              },
                              expression: "scope.row.dstWarehouseId"
                            }
                          },
                          _vm._l(_vm.wareHouseInList, function(item) {
                            return _c("el-option", {
                              key: item.id,
                              attrs: { label: item.name, value: item.id }
                            })
                          })
                        )
                      ]
                    }
                  }
                ])
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "curQuantity",
                  label: "现存数量",
                  width: "80"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "right",
                  prop: "quantity",
                  label: "调拨数量",
                  width: "80"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "center",
                  prop: "theUnit",
                  label: "单位",
                  width: "60"
                }
              }),
              _vm._v(" "),
              _c("el-table-column", {
                attrs: {
                  align: "left",
                  prop: "memo",
                  label: "备注",
                  width: "100"
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("div", { staticClass: "simple-form" }, [
        _c("div", { staticClass: "form-group center" }, [
          _vm._m(0),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-value width-1-5x" },
            [
              _c("el-input", {
                staticClass: "textarea-value",
                attrs: { type: "textarea" },
                model: {
                  value: _vm.transVoucherInfo.confirmerDesc,
                  callback: function($$v) {
                    _vm.$set(_vm.transVoucherInfo, "confirmerDesc", $$v)
                  },
                  expression: "transVoucherInfo.confirmerDesc"
                }
              })
            ],
            1
          )
        ])
      ])
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "form-label" }, [
      _c("label", {}, [_vm._v("确认描述")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-401df6f5", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-401df6f5","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/transVoucher/ShopDeviceTransVoucherLowCostConfirm.vue
// module id = 2529
// module chunks = 0